<div class="modal-header">
    <h3>Edit {{getTitle()}}</h3>
    <aurora-icon-button class="close" icon="times" variant="ghost" size="large" id="SectionModalCloseButton" aria-label="Close" (click)="activeModal.dismiss()">
    </aurora-icon-button>
</div>

<div class="modal-body">
    <div *ngFor="let element of elements">
        <sm-form-row 
            *ngIf="element.ElementType == 'Row'"
            [model]="element" 
            [readOnly]="false" 
            [formState]="formState"
            (onValueChanged)="onValueChanged.emit($event)"
            (onDetectChanges)="onDetectChanges.emit()">
        </sm-form-row>
        <sm-form-field 
            *ngIf="element.ElementType == 'Field'"
            [model]="element" 
            [readOnly]="false" 
            [formState]="formState"
            (onValueChanged)="onValueChanged.emit($event)"
            (onDetectChanges)="onDetectChanges.emit()">
        </sm-form-field>
    </div> 
</div>

<div class="modal-footer">
    <aurora-button id="SectionModalDoneButton" variant="primary" (click)="activeModal.dismiss()">Done</aurora-button>
</div>
